import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { Videos, ChannelCard } from './'
import { fatchFromApi } from '../utils/fatchFromApi'

const Channel = () => {
  const [channelDetail, setChannelDetail] = React.useState();
  const [videos, setVideos] = React.useState([]);

  const {id} = useParams();

  console.log(channelDetail, videos);

  React.useEffect(() => {
    fatchFromApi(`channels?part=snippet&id=${id}`).then((data) => setChannelDetail(data?.items[0]));
   
    fatchFromApi(`search?channelId=${id}&part=snippet&order=date`).then((data) => setVideos(data?.items));
  },[id]);
  return (
    <Box minHeight='95vh'>
      <Box>
        <div
          style={{background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(11,11,175,1) 0%, rgba(1,176,234,1) 78%, rgba(0,212,255,1) 96%)', zIndex: 10, height: '300px'}}
        />
        <ChannelCard channelDetail={channelDetail} marginTop = '-83px'/>
      </Box>
      <Box display='flex' p='2'>
          <Box sx={{mr: {sm: '100px'}}} />
          <Videos videos={videos} />
      </Box>
    </Box>
  )
}

export default Channel